import { constructIds } from "../config/common";


const errorConvertor = function (errors) {

    this.errors = errors //errors    

    this.sentences = [] //where the converted errors goes

}

errorConvertor.prototype.convert = function () {

    this.errors.forEach(error => {

        if (error.type === 'missing') {

            this.missingErrors(error);

        }

    })
}

errorConvertor.prototype.customConvert = function (msgTemplate) {
    // msgTemplate -> The [item] is used in [feature] [featureName]
    this.errors.forEach(error => {
        this.customErrors(error, msgTemplate)
    });

}

errorConvertor.prototype.customErrors = function (error, msgTemplate) {

    let keys = msgTemplate.match(/(?<=\[)[^\][]*(?=])/g);

    let value;
    keys.forEach(key => {
        if (key === 'construct' && error.construct !== undefined) {
            value = constructIds.find(item => item.type === error.construct).label
        } else {

            value = error[key];
        }
        msgTemplate = msgTemplate.replace(`[${key}]`, value);
    })
    // Check if a similar object already exists in this.sentences
    const duplicateIndex = this.sentences.findIndex(sentence => (
        sentence.error === msgTemplate && sentence.type === error.errorType
    ));

    if (duplicateIndex === -1) {
        this.sentences.push({
            error: msgTemplate,
            type: error.errorType
        });
    }
}




errorConvertor.prototype.missingErrors = function (error) {

    let itemLabel = '';

    const deleteCondition = (error.construct === undefined || error.construct === null || error.construct === "") && (error.constructName === undefined || error.constructName === null || error.constructName === "")

    if (deleteCondition) itemLabel = constructIds.find(item => item.type === error.item).label;
    else itemLabel = constructIds.find(item => item.type === error.construct).label

    const userFriendlyMessage = deleteCondition === true ?

        `${itemLabel} used in the ${error.feature} ${error.featureEntity} is ${error.type}` :

        `'${error.item}' used in the ${error.feature} ${error.featureEntity} is ${error.type} in the ${itemLabel} ${error.constructName}`

    this.sentences.push({

        error: userFriendlyMessage,
        type: error.errorType

    });
}



export default errorConvertor;

